import type { FunctionComponent } from "react";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import Spinner from "../../spinner.components";
import { useParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { useAddProposalSocialAdminHttp } from "../../../hooks/http/admin/proposal-creators/add-proposal-social.admin.http";
import useProposalSocialStore from "../../../store/proposal-creators.store";
import useProposalSocialSearchStore from "../../../store/proposal-social-search-store";

type AppProps = {
  id: string;
  className?: string;
};

export const AddSocialToFilterResult: FunctionComponent<AppProps> = ({
  id,
  className,
}) => {
  const { proposalId } = useParams();
  const { data: proposalSocials } =
    useProposalSocialStore();

  const { setData: setSearchData, data: searchData } =
    useProposalSocialSearchStore();
  const {
    execute: addProposalSocialHttp,
    fetching: fetchingAddProposalSocial,
  } = useAddProposalSocialAdminHttp();

  const { toast } = useToast();

  const handleAddSocialToFilterResult = async () => {
    if (!proposalId) {
      return;
    }
    if (!proposalSocials) {
      return;
    }
    const response = await addProposalSocialHttp({
      body: {
        social: id,
      },
      pathParams: {
        proposalId,
      },
    });
    if (!response.success) {
      return handleHttpError(response, toast);
    }

    // update search results with new data relpacing the old data at that index
    setSearchData(
      searchData.map((item) => {
        if (item.social.id === id) {
          return response.data.campaignProposalSocial;
        }
        return item;
      })
    );
    
  };

  return (
    <Button
      disabled={fetchingAddProposalSocial}
      onClick={handleAddSocialToFilterResult}
      className={`border-approvebuttonborder backdrop-blur-sm w-16 h-10 bg-approvebuttonbg border font-semibold text-approvebuttontext tracking-wider ${className}`}
    >
      {fetchingAddProposalSocial ? <Spinner width={15} /> : <Plus />}
    </Button>
  );
};
